export default __webpack_public_path__ + "static/media/shutterstock_425004079.954c84e9.jpg";